import styled from "styled-components";
import valuesCss from "../../utils/valuesCss";

const HandoutLayoutRoot = styled("div")(({ theme }) => ({
    maxWidth: 1400,
    margin: "0 auto",
    padding: valuesCss("px", 0, theme.baseUnit * 2, theme.baseUnit * 2, theme.baseUnit * 2)
}));

export default HandoutLayoutRoot;